'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$93() {
  this.c2t = null;
  this.c2u = false;
}
export { $c_Lpresto_types$$anon$93 as $c_Lpresto_types$$anon$93 };
$p = $c_Lpresto_types$$anon$93.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$93;
/** @constructor */
function $h_Lpresto_types$$anon$93() {
}
export { $h_Lpresto_types$$anon$93 as $h_Lpresto_types$$anon$93 };
$h_Lpresto_types$$anon$93.prototype = $p;
$p.P = (function() {
  if ((!this.c2u)) {
    this.c2t = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c2u = true;
  }
  return this.c2t;
});
var $d_Lpresto_types$$anon$93 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$93, "presto.types$$anon$93", ({
  YE: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$93 as $d_Lpresto_types$$anon$93 };
//# sourceMappingURL=presto.types$$anon$93.js.map
